module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsfeed"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [(_vm.grants.length > 0) ? _c('div', [_c('ul', {
    attrs: {
      "id": "grantFeed"
    }
  }, _vm._l((_vm.grants), function(grant) {
    return _c('li', [_c('div', {
      staticClass: "grant-news"
    }, [_c('router-link', {
      staticClass: "grant-title",
      attrs: {
        "to": grant.path
      }
    }, [_vm._v(_vm._s(grant.title) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "grant-date"
    }, [(_vm.isItNew(grant.posted)) ? _c('span', [_c('span', {
      staticClass: "new"
    }, [_vm._v("NEW!")]), _vm._v(" | ")]) : _vm._e(), _vm._v("\n                  Posted: " + _vm._s(_vm._f("moment")(grant.posted)) + " |\n\n                  "), _vm._v(" "), _c('span', {
      staticClass: "grant-deadline"
    }, [_vm._v("Deadline: " + _vm._s(_vm._f("moment")(grant.expired)))])]), _vm._v(" "), _c('div', {
      staticClass: "grant-description",
      domProps: {
        "innerHTML": _vm._s(grant.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "grant-readmore"
    }, [_c('router-link', {
      staticClass: "read-more-news read-more-news btn btn-secondary btn-sm\n                  btn-readmore",
      attrs: {
        "to": grant.path
      }
    }, [_vm._v("Read more >>\n                  ")])], 1)], 1)])
  }))]) : _c('div', {
    staticClass: "text-center"
  }, [_c('h2', {
    staticClass: "h4 text-muted"
  }, [_vm._v("There are no current grant opportunities.")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-481b55ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grantfeed.vue
// module id = 370
// module chunks = 0